import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["value", "disabled", "items", "name", "onChange", "className", "getItemAttributes", "getItemDisabled", "getItemIcon", "getItemKey", "getItemLabel", "getItemRef", "style"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import React, { forwardRef, useMemo } from 'react';
import { cnBem } from '@carnica/utils';
import { usePrevious } from '@beef/react';
import { composePreparedProps } from "./utils";
import styles from "./styles.pcss";
import { SegmentedControlItem } from "./SegmentedControlItem";
var cnSegmentedControl = cnBem('segmented-control', styles);
var SegmentedControlRender = function SegmentedControlRender(props, ref) {
  var _objectSpread2;
  var _composePreparedProps = composePreparedProps(props),
    value = _composePreparedProps.value,
    disabled = _composePreparedProps.disabled,
    _composePreparedProps2 = _composePreparedProps.items,
    items = _composePreparedProps2 === void 0 ? [] : _composePreparedProps2,
    _composePreparedProps3 = _composePreparedProps.name,
    name = _composePreparedProps3 === void 0 ? 'segmented-control' : _composePreparedProps3,
    onChange = _composePreparedProps.onChange,
    className = _composePreparedProps.className,
    getItemAttributes = _composePreparedProps.getItemAttributes,
    getItemDisabled = _composePreparedProps.getItemDisabled,
    getItemIcon = _composePreparedProps.getItemIcon,
    getItemKey = _composePreparedProps.getItemKey,
    getItemLabel = _composePreparedProps.getItemLabel,
    getItemRef = _composePreparedProps.getItemRef,
    style = _composePreparedProps.style,
    otherProps = _objectWithoutProperties(_composePreparedProps, _excluded);
  var activeIndex = useMemo(function () {
    return value ? items.findIndex(function (item) {
      return getItemKey(item) === getItemKey(value);
    }) : -1;
  }, [items, value]);
  var previousActiveIndex = usePrevious(activeIndex);
  var handleChange = function handleChange(item) {
    return function (e) {
      onChange === null || onChange === void 0 ? void 0 : onChange(item, e);
    };
  };
  return /*#__PURE__*/React.createElement("div", _extends({
    className: cnSegmentedControl({
      withPointer: activeIndex >= 0,
      pointerMovable: previousActiveIndex !== -1 && activeIndex !== -1
    }, [className]),
    ref: ref,
    style: _objectSpread(_objectSpread({}, style), {}, (_objectSpread2 = {}, _defineProperty(_objectSpread2, '--segmented-control-active', "".concat(activeIndex !== -1 ? activeIndex : previousActiveIndex)), _defineProperty(_objectSpread2, '--segmented-control-count', "".concat(items.length)), _objectSpread2))
  }, otherProps, {
    "data-t-id": "components-SegmentedControl"
  }), items.map(function (item) {
    return /*#__PURE__*/React.createElement(SegmentedControlItem, _extends({}, getItemAttributes(item) || {}, {
      checked: value ? getItemLabel(item) === getItemLabel(value) : false,
      disabled: getItemDisabled(item) || disabled,
      icon: getItemIcon(item),
      id: getItemKey(item).toString(),
      key: getItemKey(item),
      label: getItemLabel(item),
      name: "".concat(name),
      onChange: onChange ? handleChange(item) : undefined,
      ref: getItemRef(item)
    }));
  }));
};
export var SegmentedControl = /*#__PURE__*/forwardRef(SegmentedControlRender);